/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {
    active: {
      description: 'Used to mark currently active Item or and ItemGroup containing the currently active Item',
      type: 'state',
      values: [ true, false ]
    },
    expanded: {
      description: 'Applies when an ExpandCollapse panel is open and the content inside is visible',
      type: 'state',
      values: [ true, false ]
    },
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    type: {
      description: '`parent` being the toggle button for an ItemsGroup, and `child` an element of the ItemGroup',
      type: 'state',
      values: [ 'child', 'parent' ]
    }
  },
  rules: [
    {
      if: { active: true },
      tokens: { accentBackgroundColor: '#000000', backgroundColor: '#efefef' }
    },
    {
      if: { type: 'child' },
      tokens: {
        accentBackgroundColor: 'rgba(0, 0, 0, 0)',
        fontName: 'StagSans',
        fontSize: 14,
        fontWeight: '400',
        lineHeight: 1.45,
        paddingBottom: 12,
        paddingLeft: 32,
        paddingRight: 16,
        paddingTop: 12
      }
    },
    {
      if: { active: true, expanded: true, type: 'parent' },
      tokens: {
        accentBackgroundColor: 'rgba(0, 0, 0, 0)',
        backgroundColor: 'rgba(0, 0, 0, 0)'
      }
    },
    { if: { hover: true }, tokens: { backgroundColor: '#efefef' } },
    { if: { focus: true }, tokens: { backgroundColor: '#efefef' } },
    {
      if: { active: true, type: 'child' },
      tokens: {
        accentBackgroundColor: '#000000',
        accentOffset: 24,
        accentPadding: 16,
        backgroundColor: 'rgba(0, 0, 0, 0)',
        fontName: 'StagSans',
        fontWeight: '600',
        lineHeight: 1.5,
        paddingBottom: 13,
        paddingTop: 13
      }
    },
    {
      if: { active: false, hover: true, type: 'child' },
      tokens: { accentBackgroundColor: 'rgba(0, 0, 0, 0)' }
    }
  ],
  tokens: {
    accentBackgroundColor: 'rgba(0, 0, 0, 0)',
    accentOffset: 0,
    accentPadding: 0,
    accentWidth: 4,
    backgroundColor: 'transparent',
    borderColor: '#c9c8c8',
    borderStyle: 'solid',
    borderWidth: 1,
    color: '#000000',
    fontName: 'StagSans',
    fontSize: 16,
    fontWeight: '600',
    justifyContent: 'space-between',
    lineHeight: 1.5,
    paddingBottom: 12,
    paddingLeft: 24,
    paddingRight: 20,
    paddingTop: 12
  }
}
export default theme
